module.exports = __webpack_public_path__ + "static/media/animation-logo.87095675.png";